import useOnRedactionAnnotationChanged from './useOnRedactionAnnotationChanged';

export default useOnRedactionAnnotationChanged;